import { useState } from "react";
import { eye, eyeOff } from "../../assets/images/index";
import "./password-input.scss";

type Props = {
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  error?: string;
  infoText?: string;
  icon?: string; // optional info icon
};

export default function PasswordInput({
  placeholder,
  value,
  onChange,
  onBlur,
  error,
  infoText,
  icon,
}: Props) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="form-field password-field">
      <div className="password-input-wrapper">
        <input
          type={showPassword ? "text" : "password"}
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onBlur={onBlur}
        />
        <button
          type="button"
          className={`eye-icon ${showPassword ? "show" : ""}`}
          onClick={() => setShowPassword((prev) => !prev)}
        >
            <img
                src={showPassword ? eyeOff : eye}
                alt={showPassword ? "Hide password" : "Show password"}
            />
        </button>

      </div>

      {infoText && (
        <p className="password-label">
          {icon && (
            <span className="info-icon">
              <img src={icon} alt="info" />
            </span>
          )}
          <span>{infoText}</span>
        </p>
      )}

      {error && <p className="error-text">{error}</p>}
    </div>
  );
}
